const icons = {
  expert: '/static/expert.png',
  industry: '/static/industry.png'
}

const publicOptions = {
  isMore: false,
  hasMore: false,
  moreTitle: '展开'
}

const filterOptions = [
  {
    ...publicOptions,
    name: '专家类型',
    icon: icons.expert,
    prop: 'expertsType',
    tagList: [
      // { name: '全部', value: '', key: 'expertsTypeAll' },
      { name: '知识产权专家', value: '1', key: 'expertsType1' },
      { name: '专业技术专家', value: '2', key: 'expertsType2' }
    ]
  },
  {
    ...publicOptions,
    name: '所属行业',
    icon: icons.industry,
    prop: 'industry',
    tagList: [
      // { name: '全部', value: '', key: 'industryAll' },
      { name: '代理服务', value: '1', key: 'industry1' },
      { name: '法律服务', value: '2', key: 'industry2' },
      { name: '咨询服务', value: '3', key: 'industry3' },
      { name: '信息服务', value: '4', key: 'industry4' },
      { name: '企业管理', value: '5', key: 'industry5' }
    ]
  }
]

module.exports = {
  filterOptions
}
